module.exports = __webpack_public_path__ + "static/media/visa-logo.dc93aebe.svg";